// Routes are registered via router bundles; no local addRoute here.
import modules from "./store";

import { NAV_ITEMS_MODE } from "@/constants";
import { MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS } from "./constants";

const PhishTitanModule = ({ registerNavItems, store }) => {
  // Routes are already registered via router/routes/mspRoutes.js & customerRoutes.js

  store.registerModule("resolutionHistory", modules.resolutionHistory);
  store.registerModule("targetedUsers", modules.targetedUsers);
  store.registerModule("incidents", modules.incidents, {
    preserveState: !!store._state.data.incidents,
  });
  store.registerModule("incidentSummary", modules.incidentSummary);
  store.registerModule("linkLock", modules.linkLock);
  store.registerModule("notifications", modules.notifications);

  // Nav Items
  registerNavItems(NAV_ITEMS_MODE.MSP, MSP_NAV_ITEMS, CUSTOMER_NAV_ITEMS);
  registerNavItems(NAV_ITEMS_MODE.CUSTOMER_ADMIN, CUSTOMER_NAV_ITEMS);
};

export { PhishTitanModule };

export default {};
